import { useEffect, useState } from 'react';

const PageSlider = ({ children }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(false);
    const timer = setTimeout(() => setAnimate(true), 10); // slight delay ensures mounting first
    return () => clearTimeout(timer);
  }, [children]);

  return <div className={`page-slider ${animate ? 'slide-in' : ''}`}>{children}</div>;
};

export default PageSlider;
